// When a member's next FounderAssist plan refresh is ready, in words:
// "in 20 minutes", "at 3:40pm", "tomorrow at 9:14am", "on Tuesday".
// The limits themselves live on the backend (utils/founder-entitlements.js).

const DAY_MS = 24 * 60 * 60 * 1000

const clock = (d) =>
  d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }).replace(" ", "").toLowerCase()

const startOfDay = (d) => {
  const s = new Date(d)
  s.setHours(0, 0, 0, 0)
  return s.getTime()
}

export const nextRefreshText = (iso, now = new Date()) => {
  if (!iso) return null
  const at = new Date(iso)
  const ms = at.getTime() - now.getTime()
  if (ms <= 0) return "now"
  if (ms < 60 * 60 * 1000) {
    const m = Math.max(1, Math.ceil(ms / 60000))
    return `in ${m} minute${m === 1 ? "" : "s"}`
  }
  const days = Math.round((startOfDay(at) - startOfDay(now)) / DAY_MS)
  if (days === 0) return `at ${clock(at)}`
  if (days === 1) return `tomorrow at ${clock(at)}`
  return `on ${at.toLocaleDateString("en-US", { weekday: "long" })}`
}

export const PREMIUM_REFRESHES_PER_DAY = 3

// ["location", "skills", "stage"] -> "location, skills and stage"
export const listText = (items) => {
  const list = (items || []).filter(Boolean)
  if (list.length <= 1) return list[0] || ""
  return `${list.slice(0, -1).join(", ")} and ${list[list.length - 1]}`
}

// "Your location changed since your plan was last updated." null when nothing did.
export const profileChangeText = (fa) => {
  const changes = (fa && fa.profileChanges) || []
  if (!changes.length) return null
  return `Your ${listText(changes)} changed since your plan was last updated.`
}

// True when a refresh can start now. Also true once a cached nextRefreshAt has
// passed, so a page left open doesn't stay locked until the next refetch.
export const refreshAvailable = (refresh, now = Date.now()) =>
  !refresh ||
  refresh.canRefresh ||
  Boolean(refresh.nextRefreshAt && new Date(refresh.nextRefreshAt).getTime() <= now)
